import { createStructuredSelector } from 'reselect'

import {
  CODE22_REVIEW_LIST,
  CODE22_REVIEW_LIST_SUCCESS,
  CODE22_REVIEW_LIST_ERROR,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_SUCCESS,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_ERROR,
  CODE22_REVIEW_SEARCH_SET,
  CODE22_REVIEW_PAGE_SET,
  CODE22_REVIEW_VIEW_MODAL_SET,
  CODE22_REVIEW_VIEW_TAB_SET,
  CODE22_REVIEW_SEARCH_CHANGE,
  CODE22_REVIEW_HEADER,
  CODE22_REVIEW_SEARCH_PROJECT_LIST,
  CODE22_REVIEW_SEARCH_PROJECT_LIST_SUCCESS,
  CODE22_REVIEW_SEARCH_PROJECT_LIST_ERROR,
  CODE22_REVIEW_SEARCH_YEAR_LIST,
  CODE22_REVIEW_SEARCH_YEAR_LIST_SUCCESS,
  CODE22_REVIEW_SEARCH_YEAR_LIST_ERROR,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_SUCCESS,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_ERROR,
  CODE22_REVIEW_DETAIL,
  CODE22_REVIEW_DETAIL_SUCCESS,
  CODE22_REVIEW_DETAIL_ERROR,
  CODE22_REVIEW_SEARCH_DEMAND_LIST,
  CODE22_REVIEW_SEARCH_DEMAND_LIST_SUCCESS,
  CODE22_REVIEW_SEARCH_DEMAND_LIST_ERROR,
} from '../actions';

export const NAME = 'code22_review';

export const code22_reviewList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: CODE22_REVIEW_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const code22_reviewListSuccess = (data) => ({
  type: CODE22_REVIEW_LIST_SUCCESS,
  payload: data
});

export const code22_reviewListError = (error) => ({
  type: CODE22_REVIEW_LIST_ERROR,
  payload: error
});

export const code22_reviewSearchcode22_reviewGroupList = () => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST
});

export const code22_reviewSearchcode22_reviewGroupListSuccess = (data) => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_SUCCESS,
  payload: data
});

export const code22_reviewSearchcode22_reviewGroupListError = (error) => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST_ERROR,
  payload: error
});

export const code22_reviewSearchSet = (data) => ({
  type: CODE22_REVIEW_SEARCH_SET,
  payload: data
});

export const code22_reviewPageSet = (data) => ({
  type: CODE22_REVIEW_PAGE_SET,
  payload: data
});

export const code22_reviewViewModalSet = (data) => ({
  type: CODE22_REVIEW_VIEW_MODAL_SET,
  payload: data
});


export const code22_reviewHeader = (data) => ({
  type: CODE22_REVIEW_HEADER,
  payload: data
});

export const code22_reviewViewTabSet = (data) => ({
  type: CODE22_REVIEW_VIEW_TAB_SET,
  payload: data
});


export const code22_reviewSearchChangeSet = (data) => ({
  type: CODE22_REVIEW_SEARCH_CHANGE,
  payload: data
});

export const code22_reviewSearchProjectList = () => ({
  type: CODE22_REVIEW_SEARCH_PROJECT_LIST
});

export const code22_reviewSearchProjectListSuccess = (message) => ({
  type: CODE22_REVIEW_SEARCH_PROJECT_LIST_SUCCESS,
  payload: message
});

export const code22_reviewSearchProjectListError = (error) => ({
  type: CODE22_REVIEW_SEARCH_PROJECT_LIST_ERROR,
  payload: error
}); 

export const code22_reviewSearchYearList = () => ({
  type: CODE22_REVIEW_SEARCH_YEAR_LIST
});

export const code22_reviewSearchYearListSuccess = (message) => ({
  type: CODE22_REVIEW_SEARCH_YEAR_LIST_SUCCESS,
  payload: message
});

export const code22_reviewSearchYearListError = (error) => ({
  type: CODE22_REVIEW_SEARCH_YEAR_LIST_ERROR,
  payload: error
}); 


export const code22_reviewSearchcode22_reviewTypeList = () => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST
});

export const code22_reviewSearchcode22_reviewTypeListSuccess = (message) => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_SUCCESS,
  payload: message
});

export const code22_reviewSearchcode22_reviewTypeListError = (error) => ({
  type: CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST_ERROR,
  payload: error
});

export const code22_reviewDetail = (data) => ({
  type: CODE22_REVIEW_DETAIL,
  payload: data
});

export const code22_reviewDetailSuccess = (data) => ({
  type: CODE22_REVIEW_DETAIL_SUCCESS,
  payload: data
});

export const code22_reviewDetailError = (error) => ({
  type: CODE22_REVIEW_DETAIL_ERROR,
  payload: error
});

export const code22_reviewSearchDemandList = () => ({
  type: CODE22_REVIEW_SEARCH_DEMAND_LIST
});

export const code22_reviewSearchDemandListSuccess = (message) => ({
  type: CODE22_REVIEW_SEARCH_DEMAND_LIST_SUCCESS,
  payload: message
});

export const code22_reviewSearchDemandListError = (error) => ({
  type: CODE22_REVIEW_SEARCH_DEMAND_LIST_ERROR,
  payload: error
}); 
const code22_review = (state) => state[NAME];

export const code22_reviewSelector = createStructuredSelector({
  code22_review
})
